/* Sona Arts collection page (sections/sa-collection.liquid)
   Left filter sidebar: on desktop a tick, slider release or price entry applies at once;
   on phones and tablets the sidebar opens as a drawer, counts update live and
   "Show N designs" applies. Results update in place with the Section Rendering API. */
(function () {
  'use strict';
  var root = document.querySelector('[data-sac]');
  if (!root) return;
  var SID = root.getAttribute('data-sac');
  var WKEY = 'wsWishlist';
  var CKEY = 'sacCols';
  var mqDesk = window.matchMedia('(min-width: 990px)');
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var ctrl = null;
  var pctrl = null;
  var fgState = {};   /* filter group -> open / closed (kept across updates) */
  var moreState = {}; /* filter group -> "+ N more" expanded */
  var findState = {}; /* filter group -> search text */
  var lastFocus = null;

  function $(s, c) { return (c || document).querySelector(s); }
  function $$(s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); }
  function results() { return $('[data-sac-results]'); }
  function isDesk() { return mqDesk.matches; }
  function cssEsc(v) { return window.CSS && CSS.escape ? CSS.escape(v) : String(v).replace(/"/g, '\\"'); }

  /* ---------- Grid size (3 or 4 per row) ---------- */
  function setCols(n, save) {
    n = String(n);
    if (n !== '3' && n !== '4') return;
    root.setAttribute('data-cols', n);
    $$('[data-sac-cols]').forEach(function (b) { b.setAttribute('aria-pressed', b.getAttribute('data-sac-cols') === n ? 'true' : 'false'); });
    if (save) { try { localStorage.setItem(CKEY, n); } catch (e) {} }
  }
  (function () { var c = null; try { c = localStorage.getItem(CKEY); } catch (e) {} setCols(c || root.getAttribute('data-cols') || '3', false); })();

  /* ---------- URL helpers ---------- */
  function urlFromForm(form) {
    var p = new URLSearchParams();
    new FormData(form).forEach(function (v, k) {
      if (k === 'sort_by') return;
      if (String(v).trim() !== '') p.append(k, v);
    });
    var sort = new URLSearchParams(location.search).get('sort_by');
    if (sort) p.set('sort_by', sort);
    var q = p.toString();
    return location.pathname + (q ? '?' + q : '');
  }
  function sectionUrl(url) {
    var u = new URL(url, location.origin);
    u.searchParams.delete('page');
    u.searchParams.set('section_id', SID);
    return u;
  }

  /* ---------- Sidebar state kept across updates ---------- */
  function captureSide() {
    var side = $('[data-sac-side]');
    var body = $('[data-sac-side-body]');
    var a = document.activeElement;
    var focus = null;
    if (a && a.closest && a.closest('[data-sac-side]')) {
      if (a.name) focus = '[name="' + cssEsc(a.name) + '"]' + (a.type === 'checkbox' ? '[value="' + cssEsc(a.value) + '"]' : '');
      else if (a.hasAttribute('data-sac-lo')) focus = '[data-sac-lo]';
      else if (a.hasAttribute('data-sac-hi')) focus = '[data-sac-hi]';
    }
    return { scroll: side ? side.scrollTop : 0, bodyScroll: body ? body.scrollTop : 0, focus: focus };
  }
  function restoreSide(st) {
    $$('details[data-sac-fg]').forEach(function (d) {
      var k = d.getAttribute('data-sac-fg');
      if (Object.prototype.hasOwnProperty.call(fgState, k)) d.open = fgState[k];
      if (moreState[k]) {
        var list = d.querySelector('[data-sac-list]');
        var btn = d.querySelector('[data-sac-moreopts]');
        if (list && btn) { list.classList.add('is-expanded'); btn.setAttribute('aria-expanded', 'true'); btn.textContent = btn.getAttribute('data-less'); }
      }
      if (findState[k]) {
        var inp = d.querySelector('[data-sac-find]');
        if (inp) { inp.value = findState[k]; applyFind(d, findState[k]); }
      }
    });
    initRanges();
    if (!st) return;
    var side = $('[data-sac-side]');
    var body = $('[data-sac-side-body]');
    if (side) side.scrollTop = st.scroll;
    if (body) body.scrollTop = st.bodyScroll;
    if (st.focus && side) {
      var el = side.querySelector(st.focus);
      if (el) { try { el.focus({ preventScroll: true }); } catch (e) {} }
    }
  }

  /* ---------- Render ---------- */
  function render(url, opts) {
    opts = opts || {};
    var u = new URL(url, location.origin);
    u.searchParams.delete('page');
    u.searchParams.delete('section_id');
    var r = results();
    if (r) r.classList.add('is-loading');
    if (ctrl) ctrl.abort();
    if (pctrl) pctrl.abort();
    ctrl = 'AbortController' in window ? new AbortController() : null;
    var init = ctrl ? { signal: ctrl.signal, credentials: 'same-origin' } : { credentials: 'same-origin' };
    return fetch(sectionUrl(u.toString()).toString(), init)
      .then(function (res) { if (!res.ok) throw new Error('bad'); return res.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.querySelector('[data-sac-results]');
        var cur = results();
        if (!fresh || !cur) { location.href = u.toString(); return; }
        var st = captureSide();
        if (!opts.keepSide) closeSide(true);
        cur.replaceWith(fresh);
        if (!opts.pop) history.pushState({ sac: 1 }, '', u.pathname + u.search);
        restoreSide(st);
        setCols(root.getAttribute('data-cols'), false);
        markWish();
        if (opts.scroll !== false) {
          var a = $('[data-sac-anchor]');
          if (a) {
            var top = a.getBoundingClientRect().top;
            if (top < 0 || top > window.innerHeight * 0.6) {
              window.scrollTo({ top: top + window.pageYOffset, behavior: reduce ? 'auto' : 'smooth' });
            }
          }
        }
      })
      .catch(function (e) {
        if (e && e.name === 'AbortError') return;
        location.href = u.toString();
      });
  }

  /* ---------- Phones/tablets: live counts while the drawer is open ---------- */
  function preview(form) {
    var btn = form.querySelector('[data-sac-apply]');
    if (btn) btn.classList.add('is-busy');
    if (pctrl) pctrl.abort();
    pctrl = 'AbortController' in window ? new AbortController() : null;
    var init = pctrl ? { signal: pctrl.signal, credentials: 'same-origin' } : { credentials: 'same-origin' };
    fetch(sectionUrl(urlFromForm(form)).toString(), init)
      .then(function (res) { if (!res.ok) throw new Error('bad'); return res.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var c = doc.querySelector('[data-sac-count]');
        var n = c ? Number(c.getAttribute('data-sac-count')) : null;
        if (btn) {
          btn.classList.remove('is-busy');
          if (n !== null) btn.textContent = n === 0 ? 'No designs match' : 'Show ' + n + (n === 1 ? ' design' : ' designs');
        }
        var counts = {};
        $$('.sac-opt input[type="checkbox"]', doc).forEach(function (i) {
          var lab = i.closest('.sac-opt');
          var cc = lab && lab.querySelector('.sac-opt__c');
          counts[i.name + '\u0000' + i.value] = cc ? cc.textContent : '0';
        });
        $$('.sac-opt input[type="checkbox"]', form).forEach(function (i) {
          var lab = i.closest('.sac-opt');
          var cc = lab && lab.querySelector('.sac-opt__c');
          if (!cc) return;
          var k = i.name + '\u0000' + i.value;
          var v = Object.prototype.hasOwnProperty.call(counts, k) ? counts[k] : '0';
          cc.textContent = v;
          lab.classList.toggle('is-zero', v === '0' && !i.checked);
        });
      })
      .catch(function (e) { if (btn && !(e && e.name === 'AbortError')) btn.classList.remove('is-busy'); });
  }

  function apply(form) {
    if (isDesk()) render(urlFromForm(form));
    else preview(form);
  }

  /* ---------- Show more ---------- */
  function loadMore(a) {
    var u = new URL(a.href, location.origin);
    u.searchParams.set('section_id', SID);
    a.classList.add('is-loading');
    a.setAttribute('aria-busy', 'true');
    fetch(u.toString(), { credentials: 'same-origin' })
      .then(function (res) { if (!res.ok) throw new Error('bad'); return res.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var grid = $('[data-sac-grid]');
        var first = null;
        $$('[data-sac-grid] > li.sac-grid__item', doc).forEach(function (li) {
          var n = document.importNode(li, true);
          if (!first) first = n;
          grid.appendChild(n);
        });
        var curMore = $('[data-sac-morewrap]');
        var freshMore = doc.querySelector('[data-sac-morewrap]');
        if (curMore) { if (freshMore) curMore.replaceWith(document.importNode(freshMore, true)); else curMore.remove(); }
        var curPages = $('[data-sac-pages]');
        var freshPages = doc.querySelector('[data-sac-pages]');
        if (curPages && freshPages) curPages.replaceWith(document.importNode(freshPages, true));
        var shown = $('[data-sac-shown]');
        var freshShown = doc.querySelector('[data-sac-shown]');
        if (shown && freshShown) shown.textContent = shown.getAttribute('data-first') + '–' + freshShown.getAttribute('data-last');
        markWish();
        if (first) {
          var link = first.querySelector('.sac-card__title a');
          if (link) link.focus({ preventScroll: true });
        }
      })
      .catch(function () { location.href = a.href; });
  }

  /* ---------- Filter group helpers ---------- */
  function applyFind(fg, q) {
    q = String(q || '').trim().toLowerCase();
    var list = fg.querySelector('[data-sac-list]');
    if (!list) return;
    var n = 0;
    list.classList.toggle('is-searching', q !== '');
    $$('li[data-sac-v]', list).forEach(function (li) {
      var hit = q === '' || li.getAttribute('data-sac-v').indexOf(q) > -1;
      li.hidden = !hit;
      if (hit) n++;
    });
    var none = fg.querySelector('[data-sac-find-none]');
    if (none) none.hidden = n > 0;
  }

  function initRanges() {
    $$('[data-sac-range]').forEach(function (r) {
      if (r.__sac) return;
      r.__sac = 1;
      var top = Number(r.getAttribute('data-top')) || 1;
      var lo = r.querySelector('[data-sac-lo]');
      var hi = r.querySelector('[data-sac-hi]');
      var body = r.closest('.sac-fg__body');
      var pmin = body && body.querySelector('[data-sac-pmin]');
      var pmax = body && body.querySelector('[data-sac-pmax]');
      var step = Number(lo.step) || 100;
      function paint() {
        r.style.setProperty('--lo', (Number(lo.value) / top * 100) + '%');
        r.style.setProperty('--hi', (Number(hi.value) / top * 100) + '%');
        lo.style.zIndex = Number(lo.value) > top - 2 * step ? '4' : '';
      }
      function fromSlider(e) {
        var a = Number(lo.value);
        var b = Number(hi.value);
        if (a > b - step) {
          if (e && e.target === lo) { a = Math.max(0, b - step); lo.value = a; }
          else { b = Math.min(top, a + step); hi.value = b; }
        }
        if (pmin) pmin.value = a > 0 ? a : '';
        if (pmax) pmax.value = b < top ? b : '';
        paint();
      }
      function commit() { apply(r.closest('form')); }
      lo.addEventListener('input', fromSlider);
      hi.addEventListener('input', fromSlider);
      lo.addEventListener('change', commit);
      hi.addEventListener('change', commit);
      r.__sync = function () {
        var a = pmin && pmin.value !== '' ? Math.max(0, Math.min(top, Number(pmin.value))) : 0;
        var b = pmax && pmax.value !== '' ? Math.max(0, Math.min(top, Number(pmax.value))) : top;
        if (a > b) { var t = a; a = b; b = t; if (pmin) pmin.value = a || ''; if (pmax) pmax.value = b; }
        lo.value = a;
        hi.value = b;
        paint();
      };
      paint();
    });
  }

  /* ---------- Drawer (phones/tablets) and sort sheet ---------- */
  function lock() { if (!isDesk()) document.documentElement.classList.add('sac-lock'); }
  function unlock() { document.documentElement.classList.remove('sac-lock'); }
  function openSide() {
    var side = $('[data-sac-side]');
    if (!side) return;
    lastFocus = document.activeElement;
    root.classList.add('sac--side-open');
    lock();
    var x = side.querySelector('.sac-side__x');
    if (x) setTimeout(function () { try { x.focus({ preventScroll: true }); } catch (e) {} }, 60);
  }
  function closeSide(silent) {
    if (!root.classList.contains('sac--side-open')) return;
    root.classList.remove('sac--side-open');
    unlock();
    if (!silent && lastFocus && lastFocus.focus) { try { lastFocus.focus({ preventScroll: true }); } catch (e) {} }
  }
  function openSheet(name) {
    var s = $('[data-sac-sheet="' + name + '"]');
    if (!s) return;
    lastFocus = document.activeElement;
    s.hidden = false;
    lock();
    requestAnimationFrame(function () {
      s.classList.add('is-open');
      var x = s.querySelector('.sac-sheet__x');
      if (x) x.focus({ preventScroll: true });
    });
  }
  function closeSheets() {
    $$('[data-sac-sheet]').forEach(function (s) {
      if (s.hidden) return;
      s.classList.remove('is-open');
      setTimeout(function () { s.hidden = true; }, reduce ? 0 : 260);
    });
    if (!root.classList.contains('sac--side-open')) unlock();
  }
  function onMq() { if (isDesk()) { closeSide(true); unlock(); } }
  if (mqDesk.addEventListener) mqDesk.addEventListener('change', onMq); else if (mqDesk.addListener) mqDesk.addListener(onMq);

  /* ---------- Wishlist (same storage as the header count) ---------- */
  function getW() { try { return JSON.parse(localStorage.getItem(WKEY)) || []; } catch (e) { return []; } }
  function setW(w) {
    try { localStorage.setItem(WKEY, JSON.stringify(w)); } catch (e) {}
    if (typeof window.updateWishlistCount === 'function') { try { window.updateWishlistCount(); } catch (e) {} }
  }
  function markWish() {
    var w = getW();
    $$('[data-sac-wish]').forEach(function (b) {
      var on = w.indexOf(b.getAttribute('data-sac-wish')) > -1;
      b.classList.toggle('is-on', on);
      b.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
  }

  /* ---------- Scrollers ---------- */
  function syncArrows(wrap) {
    var row = wrap.querySelector('[data-sac-scroller]');
    if (!row) return;
    var max = row.scrollWidth - row.clientWidth - 2;
    var btns = wrap.querySelectorAll('[data-sac-scroll]');
    if (btns.length === 2) {
      btns[0].disabled = row.scrollLeft <= 2;
      btns[1].disabled = row.scrollLeft >= max;
      var arrows = wrap.querySelector('.sac-arrows');
      if (arrows) arrows.style.visibility = max <= 0 ? 'hidden' : '';
    }
  }
  function initScrollers() {
    $$('[data-sac-scroller-wrap]').forEach(function (wrap) {
      var row = wrap.querySelector('[data-sac-scroller]');
      if (!row || row.__sac) return;
      row.__sac = 1;
      row.addEventListener('scroll', function () { syncArrows(wrap); }, { passive: true });
      syncArrows(wrap);
    });
  }
  window.addEventListener('resize', function () { $$('[data-sac-scroller-wrap]').forEach(syncArrows); });

  /* ---------- Events ---------- */
  document.addEventListener('toggle', function (e) {
    var d = e.target;
    if (d && d.matches && d.matches('details[data-sac-fg]')) fgState[d.getAttribute('data-sac-fg')] = d.open;
  }, true);

  document.addEventListener('change', function (e) {
    var t = e.target;
    if (t.matches('[data-sac-auto]')) {
      apply(t.form);
    } else if (t.matches('[data-sac-pmin],[data-sac-pmax]')) {
      var body = t.closest('.sac-fg__body');
      var r = body && body.querySelector('[data-sac-range]');
      if (r && r.__sync) r.__sync();
      apply(t.form);
    } else if (t.matches('[data-sac-sort]')) {
      var u = new URL(location.href);
      u.searchParams.set('sort_by', t.value);
      render(u.toString());
    }
  });

  document.addEventListener('input', function (e) {
    var t = e.target;
    if (!t.matches('[data-sac-find]')) return;
    var fg = t.closest('[data-sac-fg]');
    if (!fg) return;
    findState[fg.getAttribute('data-sac-fg')] = t.value;
    applyFind(fg, t.value);
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Enter' && e.target.matches && e.target.matches('[data-sac-find]')) { e.preventDefault(); return; }
    if (e.key !== 'Escape') return;
    closeSheets();
    closeSide();
  });

  document.addEventListener('submit', function (e) {
    var f = e.target;
    if (!f.matches('[data-sac-form]')) return;
    e.preventDefault();
    closeSide(true);
    render(urlFromForm(f));
  });

  document.addEventListener('click', function (e) {
    var t = e.target;
    var el;
    if ((el = t.closest('a[data-sac-more]'))) { e.preventDefault(); loadMore(el); return; }
    if ((el = t.closest('a[data-sac-link]'))) {
      if (e.metaKey || e.ctrlKey || e.shiftKey) return;
      e.preventDefault();
      var inSide = !!el.closest('[data-sac-side]');
      closeSheets();
      if (inSide && !isDesk() && root.classList.contains('sac--side-open')) render(el.href, { keepSide: true, scroll: false });
      else render(el.href);
      return;
    }
    if ((el = t.closest('[data-sac-sortval]'))) {
      var u = new URL(location.href);
      u.searchParams.set('sort_by', el.getAttribute('data-sac-sortval'));
      closeSheets(); render(u.toString()); return;
    }
    if ((el = t.closest('[data-sac-open]'))) {
      e.preventDefault();
      if (el.getAttribute('data-sac-open') === 'filter') openSide(); else openSheet(el.getAttribute('data-sac-open'));
      return;
    }
    if ((el = t.closest('[data-sac-close]'))) { e.preventDefault(); closeSheets(); closeSide(); return; }
    if ((el = t.closest('[data-sac-cols]'))) { setCols(el.getAttribute('data-sac-cols'), true); return; }
    if ((el = t.closest('[data-sac-moreopts]'))) {
      var fg = el.closest('[data-sac-fg]');
      var list = fg && fg.querySelector('[data-sac-list]');
      if (!list) return;
      var on = list.classList.toggle('is-expanded');
      el.setAttribute('aria-expanded', on ? 'true' : 'false');
      el.textContent = on ? el.getAttribute('data-less') : el.getAttribute('data-more');
      moreState[fg.getAttribute('data-sac-fg')] = on;
      return;
    }
    if ((el = t.closest('[data-sac-wish]'))) {
      e.preventDefault();
      var h = el.getAttribute('data-sac-wish');
      var w = getW();
      var i = w.indexOf(h);
      if (i > -1) w.splice(i, 1); else w.push(h);
      setW(w); markWish(); return;
    }
    if ((el = t.closest('[data-sac-scroll]'))) {
      var wrap = el.closest('[data-sac-scroller-wrap]');
      var row = wrap && wrap.querySelector('[data-sac-scroller]');
      if (row) row.scrollBy({ left: Number(el.getAttribute('data-sac-scroll')) * row.clientWidth * 0.8, behavior: reduce ? 'auto' : 'smooth' });
      return;
    }
    if ((el = t.closest('[data-sac-readmore]'))) {
      var body = $('[data-sac-about-body]');
      if (!body) return;
      var open = body.classList.toggle('is-clamped') === false;
      el.setAttribute('aria-expanded', open ? 'true' : 'false');
      el.textContent = open ? 'Show less' : 'Read more';
      if (!open) { var ab = $('[data-sac-about]'); if (ab) ab.scrollIntoView({ block: 'start', behavior: reduce ? 'auto' : 'smooth' }); }
      return;
    }
    if ((el = t.closest('a[href="#sac-about"]'))) {
      var b2 = $('[data-sac-about-body]');
      var btn = $('[data-sac-readmore]');
      if (b2 && b2.classList.contains('is-clamped') && btn) btn.click();
    }
  });

  window.addEventListener('popstate', function () { render(location.href, { pop: true, scroll: false }); });

  markWish();
  initScrollers();
  initRanges();
})();
